import { css } from '@emotion/css';
import { colors } from 'constants/theme';
import cardBg from 'assets/images/bg/lottery_card.png';
import cardResult from 'assets/images/bg/cardResult.png';

const LotteryHomeStyle = {
    wrap: css`
        position: relative;
        display: flex;
        gap: 21px;
    `,
    card: css`
        background: url(${cardBg}) no-repeat center;
        background-size: cover;
        color: ${colors.white};
        border-radius: 12px;
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        padding-bottom: 10px;
        padding-top: 2px;
    `,
    top: css`
        width: 55%;
        margin: 30px auto 0;
        text-align: center;
        img {
            object-fit: contain;
            max-width: 130px;
            height: 100px;
        }
    `,
    issue: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 13px;
        h6 {
            font-weight: 500;
        }
    `,
    result: css`
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 3px;
        padding: 10px 0 15px;
        > div {
            display: inline-block;
            color: #000;
            margin: 0 1px;
            font-size: 26px;
            font-weight: 700;
            border-radius: 50%;
            min-width: 36px;
            min-height: 36px;
            line-height: 34px;
            /* border: 1px solid #000; */
            text-align: center;
            background: #fff url(${cardResult}) no-repeat;
            background-size: cover;
        }
    `,
    bottom: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 15px 0 0 15px;
        width: 90%;
        margin: 0 auto;
    `,
    timer: css`
        font-size: 16px;
    `,
    btnNavigate: css`
        position: absolute;
        top: 56%;
        transform: translateY(-50%);
        border-radius: 100px;
        z-index: 2;
        display: flex;
        cursor: pointer;
        background: #FFD9D9;
        &:disabled {
            opacity: 0.5;
            cursor: initial;
        }
        svg {
            polyline {
                stroke: #BC4040;
            }
        }
    `,
    btnPrev: css`
        left: -24px;
    `,
    btnNext: css`
        right: -24px;
    `,
    winnumber: css`
        width: 100%;
    `,
    btnbet: css`
        width: 45%;
        display: flex;
        cursor: pointer;
        &:hover {
            transform: scale(1.03);
        }
        img {
            width: 100%;
        }
    `,
    timecount: css`
        width: 50%;
        padding: 10px 0;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 80px;
        font-size: 15px;
        img {
            margin-right: 5px;
            width: 20px;
        }
    `,
    textrs: css`
        padding-top: 15px;
        font-size: 1rem;
        text-transform: uppercase;
        text-align: center;
        font-weight: bold;
        color: #fdcb44;
    `
};
export default LotteryHomeStyle;
